import React from 'react';
import './LoaderRadial.css';

const LoaderRadial = () => (
  <div className="chat-loader">
    <div className="loader-spinner"></div>
  </div>
);

export default LoaderRadial;